module.exports = __webpack_public_path__ + "img/emoji_2.2c05693c.png";